import { LoyaltyStickerType } from "@/loyalty/api/models/loyalty-api-models";

export interface LoyaltyStickerConfig {
    settings: {
        pages: Record<string, LoyaltyStickerType>;
        paths: Record<string, LoyaltyStickerType>;
    };
}

export const enum LoyaltyStickerSubtype {
    lotteryBounus = "lotteryBounus",
    elosBonus = "elosBonus",
}

export const ANONYMOUS_CONFIGURATION = {
    lotteryBounus: {
        stickerImage: "ico-white-present.svg",
        storageKey: "AnonymousStickerHidden",
        appSettingsKey: "Kentico:AnonymBonusStickerText",
    },
    elosBonus: {
        stickerImage: "ico-ticket-present.svg",
        storageKey: "AnonymousElosStickerHidden",
        appSettingsKey: "Kentico:AnonymElosBonusStickerText",
    },
};
